module.exports = {
	"name": "@bingads-webui-react/hoc-utils",
	"description": "Please find documentation and tutorial at http://internal-bingadsresources-westus.cloudapp.net/jsdoc/hoc-utils/index.html",
	"version": "0.0.1",
	"main": "dist/index",
	"license": "UNLICENSED",
	"peerDependencies": {
		"prop-types": "^15.6.0",
		"react": "^16.3.0"
	},
	"devDependencies": {
		"@bingads-webui-react/hoc-utils": "file:.",
		"@bingads-webui-react/react-test-setup": "^1.0.0",
		"@bingads-webui-test/iframe-driver": "^1.0.0",
		"chai": "3.5.0",
		"enzyme": "3.3.0",
		"jquery": "2.2.4",
		"react-dom": "16.3.0",
		"react-hot-loader": "4.1.2",
		"sinon": "2.0.0-pre.5"
	}
};


//////////////////
// WEBPACK FOOTER
// d:/dbs/el/aapusc/private/client-react/packages/hoc-utils/package.json
// module id = 78
// module chunks = 30